import { Tkv2MarketConditionsState } from '../types.ts';
import { CompTransactions } from './types.ts';

export const createCompTransactionsFromTkv2 = (
  comps: Tkv2MarketConditionsState['comps'],
  compSequence: string[],
): CompTransactions =>
  Object.fromEntries(
    compSequence.map((propID) => {
      const comp = comps[propID]?.property;
      const compStatus = comp?.getStructuredData('status');
      return [
        propID,
        {
          listingStatus: compStatus?.listingStatus,
          contractMonth: compStatus?.contractMonth,
          closeMonth: compStatus?.closeMonth,
        },
      ];
    }),
  );
